import { Risk } from "@/features/risks/entities/risk/model/risk.types"
import { Establishment } from "@/features/adm/entities/establishment/model/establishment.types"
import { Organization } from "@/features/adm/entities/organization/model/organization.types"
import { Unit } from "@/features/risks/entities/unit/model/unit.types"
import { Session } from "@/redux/_session.types"
import { getImageUrl } from "@/utils/get-image-url"

export async function exportRisksToPdf(
  dispatch: Function,
  risks: Risk[],
  establishment: Establishment,
  organization: Organization,
  units: Unit[],
  session: Session,
  selectedDate?: Date | null
): Promise<void> {
  const response: any = await dispatch({
    type: "QRCODE",
    payload: {
      method: "POST",
      url: "/generate/duerp",
      data: {
        risks,
        establishment: {
          id: establishment.id,
          name: establishment.name,
          address: establishment.address,
          siret: establishment.establishmentId,
          naf: establishment.industryCode
        },
        organization: {
          name: organization.name,
          siren: organization.establishmentId, // SIREN de l'organisation
          riskAttributes: organization.riskAttributes,
          severityScale: organization.severityScale,
          frequencyScale: organization.frequencyScale,
          preventionScale: organization.preventionScale,
          residualRiskScale: organization.residualRiskScale,
          rpsSeverityScale: organization.rpsSeverityScale,
          rpsFrequencyScale: organization.rpsFrequencyScale,
          rpsPreventionScale: organization.rpsPreventionScale,
          rpsResidualRiskScale: organization.rpsResidualRiskScale,
          users: (organization.Users ?? []).map((u) => ({ name: u.username, role: u.role }))
        },
        units: units.map((u) => ({
          id: u.id,
          name: u.name,
          description: u.description,
          size: u.size
        })),
        documentDate: selectedDate ?? null,
        branding: {
          primaryColor: session.accountColors.brandPrimary,
          secondaryColor: session.accountColors.brandSecondary,
          logoUrl: session.accountOptions.image
            ? getImageUrl("Accounts", session.accountId, "")
            : null
        }
      }
    }
  } as any)

  if (response?.buffer) {
    // Handle Buffer serialization from Node.js (comes as {type:"Buffer",data:[...]})
    let blobData: any
    if (response.buffer.data && Array.isArray(response.buffer.data)) {
      blobData = new Uint8Array(response.buffer.data)
    } else if (response.buffer instanceof ArrayBuffer) {
      blobData = new Uint8Array(response.buffer)
    } else {
      blobData = new Uint8Array(Object.values(response.buffer as any))
    }

    const blob = new Blob([blobData], { type: "application/pdf" })
    const url = URL.createObjectURL(blob)

    // Open in new tab
    window.open(url, "_blank")

    // Create download link and trigger download
    const link = document.createElement("a")
    link.href = url
    link.download = response.filename || "document_unique.pdf"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // Revoke URL after a short delay to ensure download starts
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 100)
  } else if (response?.error) {
    console.error("PDF generation error:", response.error)
  }
}
